import {
  Avatar,
  Badge,
  Button,
  Checkbox,
  CheckboxGroup,
  Col,
  Collapse,
  CollapsePanel,
  DatePicker,
  Descriptions,
  DescriptionsItem,
  Divider,
  Drawer,
  Dropdown,
  Form,
  FormItem,
  Input,
  InputNumber,
  InputPassword,
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutSider,
  Menu,
  MenuDivider,
  MenuItem,
  message,
  Modal,
  Popconfirm,
  Popover,
  Radio,
  RadioGroup,
  RangePicker,
  Row,
  Select,
  Spin,
  Statistic,
  SubMenu,
  Switch,
  Table,
  TabPane,
  Tabs,
  Tag,
  Textarea,
  Tooltip,
  Tree,
  TreeSelect,
  Cascader
} from "ant-design-vue";
import HForm from "@/components/HForm/index.vue";
import HTable from "@/components/HTable/index.vue";
import Iconfont from "@/components/Icon/index.vue";
import NumberRange from "@/components/NumberRange/index.vue";
import PlainButton from "@/components/PlainButton/index.vue";
import IconButton from "@/components/IconButton/index.vue";
import SelectInput from "@/components/SelectInput/index.vue";
import CheckAllSelect from "@/components/CheckAllSelect/index.vue";
import SvgIcon from "@/components/SvgIcon/index.vue";
import ListDetail from "@/components/ListDetail/index.vue";
import type { App } from "vue";

declare module "@vue/runtime-core" {
  type Fn = (config: string | any) => void;
  interface IMessage {
    success: Fn;
    error: Fn;
    warning: Fn;
    loading: Fn;
    info: Fn;
  }
  export interface ComponentCustomProperties {
    $message: IMessage;
  }
}
const components = [
  Layout,
  LayoutSider,
  LayoutHeader,
  LayoutContent,
  Row,
  Col,
  Menu,
  Statistic,
  SubMenu,
  MenuItem,
  MenuDivider,
  Button,
  Form,
  FormItem,
  Input,
  InputPassword,
  InputNumber,
  Checkbox,
  CheckboxGroup,
  Select,
  Tooltip,
  Table,
  Tag,
  Divider,
  RangePicker,
  DatePicker,
  Textarea,
  RadioGroup,
  Radio,
  Switch,
  Collapse,
  CollapsePanel,
  Descriptions,
  DescriptionsItem,
  Spin,
  Dropdown,
  Badge,
  Avatar,
  Tabs,
  TabPane,
  Tree,
  TreeSelect,
  Modal,
  Drawer,
  Popover,
  Popconfirm,
  Cascader,
  HForm,
  HTable,
  Iconfont,
  NumberRange,
  PlainButton,
  IconButton,
  SelectInput,
  SvgIcon,
  CheckAllSelect,
  ListDetail
];

export function registerComponents(app: App): void {
  for (const c of components) {
    app.component(c.name, c);
  }
}

export function registerPropertys(app: App): void {
  app.config.globalProperties.$message = message;
}
